var $c63231bcc300d0df$exports = {};
$c63231bcc300d0df$exports = {
  "Clear search": "Po\u010Disti iskanje"
};
export { $c63231bcc300d0df$exports as default };